export function normalizeChannelPlatform(platform) {
  return String(platform || '').trim().toLowerCase()
}

export function getChannelDisplayKey(platform) {
  const key = normalizeChannelPlatform(platform)
  if (!key || key === 'widget') return 'web'
  return key
}

export function formatChannelPlatformLabel(platform) {
  const value = String(platform || '').trim()
  if (!value) return 'Web'

  return value
    .replace(/[_-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export function getUniqueContactChannels(channels) {
  const seen = new Set()
  return (Array.isArray(channels) ? channels : []).filter(channel => {
    const platform = typeof channel === 'string' ? channel : channel?.platform
    const key = getChannelDisplayKey(platform)
    if (seen.has(key)) return false
    seen.add(key)
    return true
  })
}
